// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const stunfisk: PokeData = {
  "id": 618,
  "name": "stunfisk",
  "height": 7,
  "weight": 110,
  "base_experience": 165,
  "types": [
    PokeType.GROUND,
    PokeType.ELECTRIC
  ],
  "api_moves": [
    "tackle",
    "water-gun",
    "thunder-shock",
    "thunderbolt",
    "fissure",
    "bide",
    "flail",
    "mud-slap",
    "endure",
    "charge",
    "revenge",
    "camouflage",
    "mud-sport",
    "muddy-water",
    "bounce",
    "mud-shot",
    "sucker-punch",
    "mud-bomb",
    "discharge",
    "electric-terrain"
  ],
  "moves": [
    "tackle",
    "thunder-shock",
    "thunderbolt",
    "fissure",
    "mud-slap",
    "mud-shot",
    "mud-bomb",
    "electric-terrain",
    "thunder-punch",
    "volt-crash",
    "magnitude",
    "bonemerang",
    "thunder-fang"
  ],
  "evolution_chain": {
    "id": 313,
    "item": null,
    "species": [
      {
        "name": "stunfisk",
        "order": 619,
        "types": [
          PokeType.GROUND,
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 188,
    "speed": 60,
    "ability_power": 152
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
